import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IGPSTracker } from '@model/gpsTracker';
import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

interface IUseGpsTrackerKeys {
  searchValue?: string;
  sorting?: ITableSorting;
}

interface IParams {
  search?: string;
  sort?: {
    column: string;
    direction?: string;
  };
}

export const gpsTrackerKey = (keys: IUseGpsTrackerKeys): [string, string, ITableSorting | undefined] => [
  'gpsTracker',
  keys?.searchValue || '',
  keys?.sorting,
];
export const gpsTrackerFn = ({ queryKey }: QueryFunctionContext<ReturnType<typeof gpsTrackerKey>>) => {
  const params: IParams = {};

  if (queryKey[1]) {
    params.search = queryKey[1];
  }

  if (queryKey[2]?.id) {
    const direction = queryKey[2].desc ? 'desc' : 'asc';

    params.sort = {
      column: queryKey[2].id,
      direction,
    };
  }

  return apiClient.get(`${APP_API_URL_V2}fsd/gps-tracker`, {
    params,
  });
};

export const useGpsTrackerQuery = (keys: IUseGpsTrackerKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: gpsTrackerKey(keys),
    queryFn: gpsTrackerFn,
    useErrorBoundary: true,
    select: ({ data }: AxiosResponse<{ data: Array<IGPSTracker> }>) => data?.data || [],
    placeholderData: {
      data: {
        data: [],
      },
    },
  });
};
